// Bibliotecas de terceiros
import axios from "axios"; // Para requisições HTTP
import ReactQuill from 'react-quill'; // Editor de texto rico
import { useAuthHeader } from 'react-auth-kit'; // Para autenticação
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Para ícones
import { faGear, faEraser, faCopy, faRotateLeft, faTrashCan, faCommentMedical, faPlus, faMinus, faUserPlus, faWandMagicSparkles, faFileLines, faBold, faItalic, faUnderline } from '@fortawesome/free-solid-svg-icons'; // Ícones específicos

// React e Hooks
import React, { useState, useRef, useEffect } from "react"; // Core do React e hooks essenciais
import { useNavigate } from 'react-router-dom'; // Para navegação entre rotas

// Componentes de UI (React Bootstrap)
import { Container, Row, Col, ListGroup, Stack, Tab, Tabs } from "react-bootstrap";

// Estilos
import 'react-quill/dist/quill.snow.css'; // Estilos para o ReactQuill
import './Editor.css'; // Estilos customizados para o componente Editor


const backend = process.env.REACT_APP_BACKEND_API;

const markdownToHtml = (value = "") => {
  const escaped = value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/__([^_]+)__/g, "<strong>$1</strong>")
    .replace(/\*([^*]+)\*/g, "<em>$1</em>")
    .replace(/^### (.+)$/gm, "<strong>$1</strong>")
    .replace(/^## (.+)$/gm, "<strong>$1</strong>")
    .replace(/^# (.+)$/gm, "<strong>$1</strong>")
    .replace(/^[-*] (.+)$/gm, "• $1")
    .replace(/\n/g, "<br />");
  return escaped;
};

function Principal({ selectedModel = 'gpt-5.6-luna' }) {
  const authHeader = useAuthHeader(); // Obter o cabeçalho de autenticação
  const token = authHeader(); // Token de autenticação
  const navigate = useNavigate(); // Navegação
  const versao = process.env.REACT_APP_VERSAO; // Variável para versão

  const [texto, setTexto] = useState([""]); // Estado para armazenar o texto
  const [aba, setAba] = useState(0); // Estado para armazenar a aba atual
  const [chatText, setchatText] = useState(["Pergunte ou peça modificações no texto..."]); // Estado para armazenar o texto
  const [chatTextType, setchatTextType] = useState(["assistant"]); // Array para armazenar o tipo de chatText, começando com "assistant"
  const [empty, setEmpty] = useState(true); // Estado para verificar se está vazio
  const [isLoading2, setIsLoading2] = useState(false); // Estado para controlar o carregamento
  const [modelList, setModelList] = useState([]); // Lista de modelos
  const [templateList, setTemplateList] = useState([]); // Lista de templates
  const [prompt, setPrompt] = useState(""); // Estado para armazenar o prompt
  
  const chatTextRef = useRef(null);
  const editorRef = useRef(null);
  const [tabTitles, setTabTitles] = useState(["Paciente"]);
  const [tabIds, setTabIds] = useState(["tab-1"]);
  const [loadingTabs, setLoadingTabs] = useState({});
  const tabTitlesRef = useRef(["Paciente"]);
  const tabIdsRef = useRef(["tab-1"]);
  const textRef = useRef([""]);
  const historyRef = useRef({ "tab-1": [] });
  const [, setHistoryVersion] = useState(0);

  useEffect(() => {
    tabIdsRef.current = tabIds;
    tabTitlesRef.current = tabTitles;
    textRef.current = texto;
  }, [tabIds, tabTitles, texto]);

  const updateTabContent = (index, value, saveHistory = true) => {
    const tabId = tabIdsRef.current[index];
    const previousValue = textRef.current[index] || "";
    if (previousValue === value) return;

    if (saveHistory && tabId) {
      historyRef.current[tabId] = [...(historyRef.current[tabId] || []), previousValue].slice(-20);
    }
    const nextText = [...textRef.current];
    nextText[index] = value;
    textRef.current = nextText;
    setTexto(nextText);
    setHistoryVersion((version) => version + 1);
  };

  const updateTabContentById = (tabId, value, saveHistory = false) => {
    const index = tabIdsRef.current.indexOf(tabId);
    if (index >= 0) updateTabContent(index, value, saveHistory);
  };

  const addDocumentTab = (title, content = "", { activate = true, loading = false } = {}) => {
    const newTabId = `tab-${Date.now()}-${tabIdsRef.current.length}`;
    const nextIds = [...tabIdsRef.current, newTabId];
    const nextText = [...textRef.current, content || ""];
    const nextTitles = [...tabTitlesRef.current, title || `Documento ${nextIds.length}`];

    tabIdsRef.current = nextIds;
    tabTitlesRef.current = nextTitles;
    textRef.current = nextText;
    historyRef.current[newTabId] = [];
    setTabIds(nextIds);
    setTexto(nextText);
    setTabTitles(nextTitles);
    if (loading) {
      setLoadingTabs((current) => ({ ...current, [newTabId]: true }));
    }
    if (activate) setAba(nextIds.length - 1);
    setHistoryVersion((version) => version + 1);
    return newTabId;
  };

  const formatActiveText = (format) => {
    const quill = editorRef.current?.getEditor();
    if (!quill) return;
    const selection = quill.getSelection();
    const active = selection ? quill.getFormat(selection)[format] : false;
    quill.format(format, !active);
  };

  useEffect(() => {
    if (chatTextRef.current) {
      chatTextRef.current.scrollTop = chatTextRef.current.scrollHeight;
    }
  }, [chatText]);

  useEffect(() => {
    async function fetchData(){
      try {
        const config = {
          headers: {
            Authorization: `${token}`,
          },
        };
        const response = await axios.get(backend + "/models", config);
        setModelList(response.data);
        const response2 = await axios.get(backend + "/templates", config);
        setTemplateList(response2.data);
      } catch (error) {
          console.log(error);
      }
    }
    fetchData();
  }, [token]);
  
  async function processaTexto(nome, regra) {
    const sourceText = textRef.current[0] || "";
    const targetTabId = addDocumentTab(nome, "", { activate: false, loading: true });
    let resultText = ''; 
    const datejs = new Date();

    // Formatando para dd/mm/YYYY
    const dia = String(datejs.getDate()).padStart(2, "0");
    const mes = String(datejs.getMonth() + 1).padStart(2, "0"); // Meses começam do 0
    const ano = datejs.getFullYear();
  
    const hoje = `${dia}/${mes}/${ano}`;

    try {
      const response = await axios.post(
        backend + "/gen_old", 
      {
      "prompt": "Utilizando as informações do paciente fornecidas, atue como um auxiliar na organização de prontuários médicos. Utilize apenas as informações que forem dadas, não crie dados novos. Substitua <hoje> pela data de hoje, que é:" + hoje + ". Siga as instruções e modelo: " + regra + " Informações do paciente: ```" + sourceText + "```",
       "model": selectedModel,
      },
      {
        "headers": {
        "Authorization": `${token}`,
        },
      }
      );

      resultText = response.data.result.replace(/\n/g, '<br>');
    
      updateTabContentById(targetTabId, resultText);
    } catch (error) {
      console.error(error);
      updateTabContentById(targetTabId, "Não foi possível gerar este documento. Revise os dados do paciente e tente novamente.");
    } finally {
      setLoadingTabs((current) => {
        const next = { ...current };
        delete next[targetTabId];
        return next;
      });
    }
  };

  
  function htmlToPlainText(htmlString) {
    // Substitui <p><br></p> por uma linha em branco (\n\n)
    let text = htmlString.replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '\n\n');
  
    // Substitui <br> por uma quebra de linha
    text = text.replace(/<br\s*\/?>/gi, '\n');
  
    // Substitui <p> por nada e </p> por uma quebra de linha
    text = text.replace(/<p>/gi, '').replace(/<\/p>/gi, '\n');
  
    // Decodifica entidades HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    let decoded = doc.documentElement.textContent;
  
    // Remove múltiplas quebras extras e faz um trim para manter o formato correto
    decoded = decoded.replace(/\n{3,}/g, '\n\n').trim();
  
    return decoded;
  }

  const handleCopyToClipboard = async () => {
    const html = texto[aba] || "";
    const plaintxt = htmlToPlainText(html);
    if (!plaintxt) {
      window.alert("Não há conteúdo para copiar.");
      return;
    }

    try {
      if (navigator.clipboard && typeof ClipboardItem !== "undefined") {
        const clipboardItem = new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([plaintxt], { type: "text/plain" }),
        });
        await navigator.clipboard.write([clipboardItem]);
      } else {
        await navigator.clipboard.writeText(plaintxt);
      }
    } catch (error) {
      console.error("Erro ao copiar conteúdo:", error);
      window.alert("Não foi possível copiar o conteúdo.");
    }
  };
  
  async function goChat() {
    const promptToSend = prompt.trim();
    if (!promptToSend || isLoading2) return;

    const targetTabId = tabIdsRef.current[aba];
    const sourceText = textRef.current[aba] || "";
    setchatText(prevChattext => [...prevChattext, promptToSend]);
    setchatTextType(prevChatTextType => [...prevChatTextType, 'user']);
    setIsLoading2(true);
    try {
      const response = await axios.post(
        backend + "/gen_old", 
        {
          "prompt": `Considere que você é um médico. Considere o texto sobre o paciente que
          está entre as tags <info> e a solicitação do usuário que está nas tags <prompt>, assim como a conversa prévia atual que está
          nas tags <conversa>. Caso a solicitação não tenha a ver com a sua função, negue educadamente. Caso necessite de mais informações,
          pergunte antes de responder. Caso o usuário solicite alguma mudança no texto, retorne a sua resposta nas tags <resposta> e o texto
          atualizado entre as tags <novo_texto>.
          <conversa>${chatText}</conversa>
          <info>${sourceText}</info>
          <prompt>${promptToSend}</prompt>`,
          "model": selectedModel,
        },
        {
          "headers": {
            "Authorization": `${token}`,
          },
        }
      );
      const respostaRegex = /<resposta>(.*?)<\/resposta>/s;
      const novoTextoRegex = /<novo_texto>(.*?)<\/novo_texto>/s;

      const respostaMatch = response.data.result.match(respostaRegex);
      const novoTextoMatch = response.data.result.match(novoTextoRegex);

      const resposta = respostaMatch ? respostaMatch[1] : "";
      const novoTexto = novoTextoMatch ? novoTextoMatch[1] : "";

      if (novoTexto) {
        updateTabContentById(targetTabId, novoTexto);
      }

      if (resposta) {
        setchatText(prevChattext => [...prevChattext, resposta]);
        setchatTextType(prevChatTextType => [...prevChatTextType, 'assistant']);
      } else {
        setchatText(prevChattext => [...prevChattext, response.data.result]);
        setchatTextType(prevChatTextType => [...prevChatTextType, 'assistant']);
      }
      //setchatText(prevChattext => prevChattext + '<p class="user">' + prompt + '</p>' + '<p class="assistant">' + response.data.result.replace(/\n/g, '<br>') + '</p>');
      setPrompt("");
    } catch (error) {
      console.error("Erro ao gerar texto:", error);
      alert("Erro no chat: " + (error.response?.data?.details || error.response?.data?.message || error.response?.data?.error?.message || error.message));
    }
    setIsLoading2(false);
  };


  useEffect(() => {
    const regex = /<\s*[^>]*>/g;
    const currentText = texto[0] || "";
    const onlyTags = currentText.replace(regex, "").trim() === "";
    setEmpty(currentText === "" || onlyTags);
  }, [texto]);

  const handleTextoChange = (index, value) => {
    updateTabContent(index, value);
  };

  const handleUndo = () => {
    const tabId = tabIdsRef.current[aba];
    const tabHistory = historyRef.current[tabId] || [];
    const previousValue = tabHistory.pop();
    if (previousValue === undefined) return;

    updateTabContent(aba, previousValue, false);
    setHistoryVersion((version) => version + 1);
  };

  const canUndo = (historyRef.current[tabIds[aba]] || []).length > 0;

  const resetPatient = () => {
    if (isLoading2) return;
    const initialTabId = `tab-${Date.now()}-patient`;
    tabIdsRef.current = [initialTabId];
    textRef.current = [""];
    historyRef.current = { [initialTabId]: [] };
    tabTitlesRef.current = ["Paciente"];
    setLoadingTabs({});
    setTabIds([initialTabId]);
    setTexto([""]);
    setTabTitles(["Paciente"]);
    setAba(0);
    setPrompt("");
    setchatText(["Pergunte ou peça modificações no texto..."]);
    setchatTextType(["assistant"]);
    setHistoryVersion((version) => version + 1);
  };
  
  return (
    <Container fluid className="editor-page">
      <Row className="editor-layout g-3">
        <Col md={2} className="sidebar editor-sidebar">
            <ListGroup className='tool-group' variant="flush">
              <ListGroup.Item className="sidebar-title">
                <span><FontAwesomeIcon icon={faWandMagicSparkles} /> Prompts</span>
                <FontAwesomeIcon className="mx-1 cursor" onClick={() => navigate("/edit/models")} icon={faGear}/>
              </ListGroup.Item>
              {modelList.length === 0 && <ListGroup.Item className="empty-tool" disabled>Carregando ferramentas...</ListGroup.Item>}
              {modelList.map((model) => (
                <ListGroup.Item key={model.name} action disabled={empty} onClick={() => processaTexto(model.name, model.data)}>{model.name}</ListGroup.Item>
              ))}
            </ListGroup>
            <ListGroup className='tool-group' variant="flush">
              <ListGroup.Item className="sidebar-title">
                <span><FontAwesomeIcon icon={faFileLines} /> Modelos</span>
                <FontAwesomeIcon className="mx-1 cursor" onClick={() => navigate("/edit/templates")} icon={faGear}/>
              </ListGroup.Item>
              {templateList.map((model) => (
                <ListGroup.Item key={model.name} action disabled={isLoading2} onClick={() => {
                  addDocumentTab(model.name, model.data);
                }}><FontAwesomeIcon icon={faFileLines} />{model.name}</ListGroup.Item>
              ))}
            </ListGroup>
        </Col>
            <Col md={7} className="editor-document px-1">
            <Row className="mb-2">
              <div className="document-toolbar">
              <div className="tabs-container">
              <Tabs
                activeKey={tabIds[aba]}
                id="editor-tabs"
                className="mb-3 custom-tabs document-tabs"
                onSelect={(selectedKey) => {
                  if (selectedKey === "tab_mais") {
                    const novoTitulo = `Novo documento ${texto.length}`;
                    addDocumentTab(novoTitulo, "", { activate: true });
                  } else  if (selectedKey === "tab_menos") {
                    if (texto.length > 1) {
                      const nextText = texto.filter((_, index) => index !== aba);
                      const nextTitles = tabTitles.filter((_, index) => index !== aba);
                      const nextIds = tabIds.filter((_, index) => index !== aba);
                      delete historyRef.current[tabIds[aba]];
                      setTexto(nextText);
                      setTabTitles(nextTitles);
                      tabTitlesRef.current = nextTitles;
                      setTabIds(nextIds);
                      setAba(Math.min(aba > 0 ? aba - 1 : 0, nextIds.length - 1));
                    }
                  } else {
                    const index = tabIds.indexOf(selectedKey);
                    if (index >= 0) setAba(index);
                  }
                }}
                >
              {texto.map((_, index) => (
                    <Tab 
                      eventKey={tabIds[index]}
                      title={<span className="document-tab-title">{loadingTabs[tabIds[index]] && <img src="./loading.svg" alt="" />} {tabTitles[index]}</span>}
                      key={tabIds[index]}>
                      <div style={{ position: 'relative' }}>
                        <div className="document-edit-toolbar" aria-label="Ações e formatação do documento">
                          <div className="document-actions">
                            <button type="button" className="document-action-button" onClick={resetPatient} title="Novo paciente" aria-label="Novo paciente"><FontAwesomeIcon icon={faUserPlus} /></button>
                            <button type="button" className="document-action-button" onClick={handleCopyToClipboard} title="Copiar texto" aria-label="Copiar texto"><FontAwesomeIcon icon={faCopy} /></button>
                            <button type="button" className="document-action-button" onClick={handleUndo} disabled={!canUndo} title="Desfazer" aria-label="Desfazer"><FontAwesomeIcon icon={faRotateLeft} /></button>
                            <button type="button" className="document-action-button document-action-danger" onClick={() => updateTabContent(aba, "")} title="Apagar documento" aria-label="Apagar documento"><FontAwesomeIcon icon={faTrashCan} /></button>
                          </div>
                          <div className="inline-format-toolbar" aria-label="Formatação">
                            <button type="button" className="document-action-button" onClick={() => formatActiveText("bold")} title="Negrito" aria-label="Negrito"><FontAwesomeIcon icon={faBold} /></button>
                            <button type="button" className="document-action-button" onClick={() => formatActiveText("italic")} title="Itálico" aria-label="Itálico"><FontAwesomeIcon icon={faItalic} /></button>
                            <button type="button" className="document-action-button" onClick={() => formatActiveText("underline")} title="Sublinhado" aria-label="Sublinhado"><FontAwesomeIcon icon={faUnderline} /></button>
                          </div>
                        </div>
                        {loadingTabs[tabIds[index]] ? (
                          <div className="tab-loading-state">
                            <img src="./loading.svg" alt="" />
                            <span>Gerando documento...</span>
                          </div>
                        ) : (
                          <ReactQuill
                            ref={index === aba ? editorRef : null}
                            className="quill-editor"
                            onChange={(value) => handleTextoChange(index, value)}
                            value={texto[index]}
                            placeholder={index === 0 ? "Coloque os dados do paciente aqui e escolha um prompt ou modelo para gerar os documentos." : "Revise ou edite o documento gerado aqui..."}
                            modules={{ toolbar: false }}
                            formats={['bold', 'italic', 'underline']}
                          />
                        )}
                      </div>
                    </Tab>
                  ))}
                  <Tab eventKey="tab_mais" title={<FontAwesomeIcon icon={faPlus} />}></Tab>
                  <Tab eventKey="tab_menos" title={<FontAwesomeIcon icon={faMinus} />} disabled={texto.length <= 1}></Tab>
              </Tabs>
                  </div>
              </div>
            </Row>
            <Row>
              <footer>
                <p className="footer-text text-center">⚠ Textos gerados por inteligência artificial podem conter informações imprecisas. Revise tudo antes de usar em um contexto real.</p>
                <p className="footer-text text-center">Versão {versao} · &copy;2026 <a href="https://www.tbmed.com.br" className="no-link">TBMed Serviços Médicos</a> LTDA.</p>
              </footer>
            </Row>
        </Col>
        <Col md={3} className="editor-chat-column">
          <Stack gap={0} className="editor-chat-stack">
            <div className="chat">
              <h1><span><FontAwesomeIcon icon={faCommentMedical} /> Assistente HealthPad</span> <FontAwesomeIcon className="mx-1 cursor chat-clear" title="Limpar conversa" onClick={() => { setchatText(['Pergunte ou peça modificações no texto...']); setchatTextType(['assistant']); }} icon={faEraser}/></h1>
              <div className="chattext" ref={chatTextRef}>
                {chatText.map((text, index) => (
                  <p key={index} className={chatTextType[index]} dangerouslySetInnerHTML={{ __html: markdownToHtml(text) }}></p>
                ))}
              </div>
              {isLoading2 && <p className="chatloading">Carregando...</p>}
              </div>
              <div className="chat-input-wrap">
                <textarea
                  rows="2" 
                  className="form-control chatinput" 
                  placeholder="Digite aqui e tecle Enter..." 
                  value={prompt} 
                  onChange={(e) => setPrompt(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      goChat();
                      e.preventDefault();
                    }
                }}
                ></textarea>
                <span className="chat-input-hint">Enter para enviar</span>
              </div>
          </Stack>
        </Col>
      </Row>

    </Container>
  );
}

export default Principal;